export default function (number: number | null | undefined): number {
    return number || 0;
}
